import { Typography, Box } from "@mui/material";
import { ReactNode } from "react";

interface ProgramCardProps {
  programName: string;
  programColor?: string;
  children: ReactNode;
}

export const ProgramCard = ({
  programName,
  programColor,
  children,
}: ProgramCardProps) => {
  const bgColor = programColor || "#d3d3d3";
  const bgColorDark = programColor || "#d3d3d3";

  return (
    <Box
      data-cypress="program-card"
      data-program-name={programName}
      sx={{
        backgroundColor: bgColor,
        boxShadow: `inset 0 6px 5px -6px ${bgColorDark}, inset 0 -6px 5px -6px ${bgColorDark}`,
        mb: 2,
      }}
    >
      <Box sx={{ p: 0, pb: 0 }}>
        <Typography sx={{ p: 1, pt: 1.5 }} variant="h6">
          {programName || "Program"}
        </Typography>
        <Box
          className="reward-options"
          sx={{
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            pb: 0.3,
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
